import moment from 'moment-timezone';

export interface FilterValues {
    datumVon: string;
    datumBis: string;
    artikelGruppeNr?: number;
    betreuer?: number;
    telBetreuer?: number;
}

export const defaultFilterValues: FilterValues = {
    artikelGruppeNr: undefined,
    datumVon: moment().subtract({ months: 3 }).startOf('year').format('YYYY-MM-DD'),
    datumBis: moment().format('YYYY-MM-DD'),
    betreuer: undefined,
    telBetreuer: undefined,
};

/*
export interface LineData {
    auNr: string;
    datum: string;
    kNr: number;
    kName: string;
    artikelGruppeNr: number;
    artikelNr: string;
    pos: number;
    posText: string;
    posEinh: string;
    posMenge: number;
    posEkPreis: number;
    posEPreis: number;
    posNetto: number;
    posMwst: number;
    posBrutto: number;
    posBem: string;
    lArt: string;
}

export const defaultLineData: LineData = {
    auNr: '',
    datum: '',
    kNr: 0,
    kName: '',
    artikelGruppeNr: 0,
    artikelNr: '',
    pos: 0,
    posText: '',
    posEinh: '',
    posMenge: 0,
    posEkPreis: 0,
    posEPreis: 0,
    posNetto: 0,
    posMwst: 0,
    posBrutto: 0,
    posBem: '',
    lArt: '',
};

export interface ArtikeluebersichtSummary {
    loading: boolean;
    // total: LineData;
    lineDataList: LineData[];
    // betreuerTotal: { [key: string]: LineData };
    // telBetreuerTotal: { [key: string]: LineData };
}
 */

export interface Pillar {
    x: number;
    y: number;
    height: number;
    color: string;
    artikelGruppeNr: number;
    artikelNr: string;
    totalMenge: number;
    auNrList: string[];
    month: string;
    value: number;
}

export interface AxisLabel {
    type: 'artikeldetail' | 'month';
    label: string;
    x: number;
    y: number;
}
